<template>
  <div class="por-producto d-flex flex-column flex-grow-1">
    <div class="px-3 py-2 ">
      <ProductoSelectComponent
        :current="current"
        title="SKU / Código de Producto"
        :disabled_view="true"
      />
    </div>
    <div
      v-if="current.producto && !cargando"
      class="px-3 py-2 d-flex align-items-center flex-wrap"
      style="background:#f8f9fa; gap:10px; flex-wrap:wrap"
    >
      <span class="mb-0 d-flex align-items-center">
        <i class="fas fa-box mr-2 text-primary"></i>
        <span class="mr-2">Unidad de Compra:</span>
        <span class="badge badge-pill badge-info px-3 py-2">
          {{ (current.producto.unidad_medida_compra_obj && current.producto.unidad_medida_compra_obj.nombre) || '—' }}
        </span>
      </span>

      <span class="ml-auto"></span>

      <h6 v-if="editedCount > 0" class="mb-0">
        <span class="badge badge-warning px-3 py-2">
          <i class="fas fa-pencil-alt mr-2"></i>
          {{ editedCount }} cambio{{ editedCount > 1 ? 's' : '' }} pendiente{{ editedCount > 1 ? 's' : '' }} de guardar
        </span>
      </h6>
    </div>
    <div
      v-if="!current.producto && !cargando"
      class="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-muted"
    >
      <i class="fas fa-search fa-3x mb-3" style="opacity:0.2"></i>
      <p class="mb-0">Ingresa un SKU para ver la configuración por tienda</p>
    </div>
    <div
      v-if="cargando"
      class="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-muted"
    >
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="sr-only">Cargando...</span>
      </div>
      <p class="mb-0">Cargando configuración...</p>
    </div>
    <div v-if="current.producto && !cargando" class="d-flex flex-column ">

      <div class="d-flex justify-content-end mb-2 gap-2 border-bottom pb-2">
        <button class="btn btn-outline-secondary btn-sm" :disabled="guardando || editedCount === 0" @click="$refs.configTable.descartarTodosLosCambios()">
          <i class="fas fa-undo mr-1"></i>
          Descartar
        </button>
        <button class="btn btn-success btn-sm" :disabled="guardando || editedCount === 0" @click="guardarCambios">
          <span v-if="guardando" class="spinner-border spinner-border-sm mr-1" role="status"></span>
          <i v-else class="fas fa-save mr-1"></i>
          {{ guardando ? 'Guardando...' : `Guardar ${editedCount} cambio${editedCount > 1 ? 's' : ''}` }}
        </button>
      </div>
      <div class="flex-grow-1 p-2 d-flex flex-column mt-4">
        <ProductoTiendaConfigTable
          ref="configTable"
          :configuraciones_producto_tienda="config_producto_en_tiendas"
          :allowed-units="allowedUnits"
          max-height="65vh"
          @edited-count-change="c => editedCount = c"
          @refresh-existencia="onRefreshExistencia"
          @error-existencia="msg => Notifications.alert.error('Error', msg)"
        >
          <template #columns-start>
            <th scope="col" class="align-middle" style="min-width:50px">ID</th>
            <th scope="col" class="align-middle" style="min-width:150px">Tienda</th>
          </template>

          <template #cells-start="{ item }">
            <td class="align-middle small text-muted font-weight-bold">
              {{ item.codigo_tienda }}
            </td>
            <td class="align-middle">
              <span class="font-weight-500">{{ item.nombreTienda }}</span>
              <span v-if="item.deshabilitado" class="badge badge-secondary ml-1">No asignado</span>
              <span v-if="!item.activo && !item.deshabilitado" class="badge badge-danger ml-1">inactivo</span>
              <small v-if="item.errorInactivacion && !item.activo" class="d-block text-danger font-weight-bold" :title="item.errorInactivacion">{{ item.errorInactivacion }}</small>
            </td>
          </template>
        </ProductoTiendaConfigTable>
      </div>
    </div>
    <ModalAgregarTiendaProductoComponent
      :visible="showAgregarModal"
      :tiendasNoAsignadas="tiendasNoAsignadas"
      :allowed-units="allowedUnits"
      :producto-sku="current.producto && current.producto.sku ? current.producto.sku : ''"
      @close="showAgregarModal = false"
      @saved="onTiendaAgregada"
      @error="onModalError"
    />
    <div class="my-4 bg-warning border p-4 rounded" v-if="current.producto && !cargando">
      <small class="font-weight-bold"
      >Tomar en cuenta lo siguiente:
      <br />
      <i class="fas fa-info-circle"></i>
        Cualquier modificación realizada en la configuración esta bajo
        su propia responsabilidad.
      <br />
      <i class="fas fa-info-circle"></i>
        Recuerde no modificar datos que no correspondan a su tienda de
        trabajo, cualquier modificación realizada quedara registrada
        con su información usuario.</small
      >
    </div>
  </div>
</template>

<script>
import ProductoSelectComponent from '@/components/commons/ProductoSelectComponent'
import ModalAgregarTiendaProductoComponent from './ModalAgregarTiendaProductoComponent'
import ProductoTiendaConfigTable, { CAMPOS_TRACKED } from './ProductoTiendaConfigTable.vue'
import { clonarProfundo } from '@/utils'
import DynamicService from '@/services/commons/DynamicService'
import Notifications from '@/notifications/notifications'

export default {
  name: 'PorProducto',
  components: { ProductoSelectComponent, ModalAgregarTiendaProductoComponent, ProductoTiendaConfigTable },

  data() {
    return {
      current: { producto: null, errors: {} },
      config_producto_en_tiendas: [],
      allowedUnits: [],
      editedCount: 0,
      cargando: false,
      guardando: false,
      showAgregarModal: false,
    }
  },
  computed: {
    tiendasNoAsignadas() {
      return this.config_producto_en_tiendas.filter(s => s && s.deshabilitado)
    },
  },
  watch: {
    'current.producto'(producto) {
      if (producto && producto.sku) {
        this.onProductoEncontrado(producto)
      } else {
        this.config_producto_en_tiendas = []
        this.allowedUnits = []
      }
    },
  },
  mounted() {
    this.$root.$on('pt:agregar-tienda', this.onAgregarTiendaEvent)
  },
  destroyed() {
    this.$root.$off('pt:agregar-tienda', this.onAgregarTiendaEvent)
  },
  methods: {
    async onProductoEncontrado(producto) {
      this.cargando                   = true
      this.config_producto_en_tiendas = []
      this.allowedUnits               = []
      const sku = producto.sku  

      try {
        const [ptResponse, tiendasResponse, unidadesResponse] = await Promise.all([
          DynamicService.getActionList(
            'cat', 'producto-tienda',
            'obtener_producto_tiendas_detalle_x_sku',
            { sku }
          ),
          DynamicService.fetch('cat', 'tiendas', { quitar_paginacion: true }),
          DynamicService.fetch('cat', 'producto-unidad_medida', { producto: sku, limit: 1000 }),
        ])

        const productoTiendas = ptResponse.data && ptResponse.data.results ? ptResponse.data.results : ptResponse.data ||  []
        const tiendasData     = tiendasResponse.data
        this.allowedUnits     = unidadesResponse && unidadesResponse.data && unidadesResponse.data.results ? unidadesResponse.data.results : []
        this.construirConfigProductoEnTiendas(sku, productoTiendas, tiendasData)

      } catch (error) {
        Notifications.alert.error('Error', 'No se pudieron cargar los datos del producto. Intente nuevamente.')
        this.current.producto           = null
        this.config_producto_en_tiendas = []
      } finally {
        this.cargando = false
      }
    },

    construirConfigProductoEnTiendas(sku, productoTiendas, tiendasData) {
      const tiendas = tiendasData && tiendasData.results ? tiendasData.results : tiendasData || []
      const ptMap = new Map(productoTiendas.map(pt => [pt.tienda, pt]))

      this.config_producto_en_tiendas = tiendas
        .filter(t => t.codigo_postal === '1' && t.nombre_comercial !== null)
        .map(tienda => {
          const pt = ptMap.get(tienda.codigo)
          const asignado = !!pt

          const item = {
            id: tienda.id || tienda.codigo,
            codigo_tienda: tienda.codigo,
            nombreTienda: tienda.nombre ,
            activo: pt ? pt.activo !== false : true,
            deshabilitado: !asignado,
            tienda: tienda.codigo,
            ...pt,
          }

          if (!item.deshabilitado) {
            item.originalValue = clonarProfundo(
              CAMPOS_TRACKED.reduce((acc, key) => {
                acc[key] = item[key]
                return acc
              }, {})
            )
          }

          return item
        })
    },

    async guardarCambios() {
      if (!this.$refs.configTable) return
      
      const registros = this.$refs.configTable.getModifiedPayloads()
      if (!registros.length) return

      this.guardando = true

      try {
        const response = await DynamicService.postActionList(
          'cat',
          'producto-tienda',
          'updates_fields_or_creates_productotienda',
          { registros_modificados: registros }
        )
        const data = response.data
        const errors = data.errores && data.errores.length > 0
        const success = (data.actualizados && data.actualizados.length > 0) || (data.creados && data.creados.length > 0)
        if (errors) {
          this._manejarErroresGuardado({ response: { data } })
        }
        if (success) {
          if (errors) {
            const clavesErrores = data.errores.map(f => f.producto + '-' + f.tienda)
            this.$refs.configTable.resetSavedItemsExcluyendo(clavesErrores)
          } else {
            this.$refs.configTable.resetSavedItems()
          }
          if (errors) {
            Notifications.alert.warning(
              'Parcial',
              `Se guardaron ${data.actualizados.length} cambio(s), pero ${data.errores.length} no se pudieron actualizar.`
            )
          } else {
            Notifications.alert.success('Éxito', 'Cambios guardados exitosamente.')
          }
        } else if (!errors) {
          Notifications.alert.error(
            'Error',
            'Error al guardar. Intente nuevamente.'
          )
        }
      } catch (error) {
        this._manejarErroresGuardado(error)
        Notifications.alert.error(
          'Error',
          error.response && error.response.data && error.response.data.detail || 'Error al guardar. Intente nuevamente.'
        )
      } finally {
        this.guardando = false
      }
    },
    _manejarErroresGuardado(error) {
      const errores = (error && error.response && error.response.data && error.response.data.errores) || error.errores || []
      if (!errores.length) {
        Notifications.alert.error(
          'Error',
          error.response && error.response.data && error.response.data.detail || 'Error al guardar. Intente nuevamente.'
        )
        return
      }
      const erroresPorRegistro = {}
      let clavesCompletas = true
      errores.forEach(f => {
        if (f.producto && f.tienda) {
          erroresPorRegistro[`${f.producto}-${f.tienda}`] = f.error
        } else {
          clavesCompletas = false
        }
      })
      if (clavesCompletas) {
        this.$refs.configTable.marcarErroresInactivacion(erroresPorRegistro)
      } else {
        Notifications.alert.error(
          'Error',
          (error.response && error.response.data && error.response.data.detail) || 'Error al guardar. Intente nuevamente.'
        )
        return
      }
    },

    onAgregarTiendaEvent() {
      if (!this.current.producto) {
        Notifications.alert.info('Búsqueda', 'Debe buscar y seleccionar un producto primero.')
        return
      }
      if (this.tiendasNoAsignadas.length === 0) {
        Notifications.alert.info('Tiendas', 'Todas las tiendas ya han sido asignadas a este producto.')
        return
      }
      this.showAgregarModal = true
    },

    onTiendaAgregada(payload) {
      const { storeId, storeCode, config } = payload
      const storeKey = storeCode || storeId
      const idx = this.config_producto_en_tiendas.findIndex(s => {
        const matchesStoreCode = s.codigo_tienda && String(s.codigo_tienda) === String(storeKey)
        const matchesStoreId = s.id && String(s.id) === String(storeKey)
        return matchesStoreCode || matchesStoreId
      })

      if (idx !== -1) {
        this.$set(this.config_producto_en_tiendas[idx], 'deshabilitado', false)
        Object.keys(config).forEach(key => {
          this.$set(this.config_producto_en_tiendas[idx], key, config[key])
        })
        if (this.$refs.configTable) {
          this.$refs.configTable.resetOriginal(this.config_producto_en_tiendas[idx])
        }
        Notifications.alert.success('Éxito', `Tienda "${this.config_producto_en_tiendas[idx].nombreTienda}" asignada correctamente.`)
      }
    },

    onModalError(error) {
      Notifications.alert.error(
        'Error',
        error.response && error.response.data && error.response.data.detail || 'Error al guardar. Intente nuevamente.'
      )
    },

    async onRefreshExistencia() {
      if (!this.current.producto) return
      try {
        const ptResponse = await DynamicService.getActionList(
          'cat', 'producto-tienda',
          'obtener_producto_tiendas_detalle_x_sku',
          { sku: this.current.producto.sku }
        )
        const productoTiendas = ptResponse.data && ptResponse.data.results ? ptResponse.data.results : ptResponse.data || []
        const ptMap = new Map(productoTiendas.map(pt => [pt.tienda, pt]))
        this.config_producto_en_tiendas.forEach(item => {
          const pt = ptMap.get(item.tienda)
          if (pt) {
            this.$set(item, 'existencia', pt.existencia || 0)
          }
        })
      } catch (error) {
        Notifications.alert.error('Error', 'No se pudo actualizar la existencia.')
      }
    },
  },
}
</script>
